import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/play.svg';
var RATIOS = {
  '16:9': 'ri-16_9',
  '100:41': 'ri-41',
  '13:3': 'ri-23',
  '9:16': 'ri-9_16',
  '8:3': 'ri-38',
  '4:3': 'ri-4_3',
  '3:4': 'ri-3_4',
  '1:1': ''
};
export default {
  name: 'RegularMediaArtDirection',
  components: {
    MdmIcon: MdmIcon
  },
  props: {
    src: {
      type: String,
      required: true
    },
    srcsets: {
      type: Object,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    videoMp4: {
      type: String,
      default: ''
    },
    videoWebm: {
      type: String,
      default: ''
    },
    ratioImg: {
      type: String,
      default: '16:9'
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    playColor: {
      type: String,
      default: 'white'
    }
  },
  data: function data() {
    return {
      isPaused: !this.autoPlay
    };
  },
  computed: {
    builderRatio: function builderRatio() {
      return RATIOS[this.ratioImg];
    }
  },
  methods: {
    toggleVideo: function toggleVideo(evt) {
      var video = evt.target;

      if (video.paused) {
        video.play();
        this.isPaused = false;
      } else {
        video.pause();
        this.isPaused = true;
      }
    }
  }
};